import type { PageData } from '../../../../_metronic/helpers/utils/types';
import { getIdealImageSize } from '../../../../_metronic/helpers/utils/utils';

export const templateData: PageData = [
  {
    formId: 'form1',
    heading: 'Hero Section',
    data: [
      { id: 'metaName', label: 'Meta title', type: 'input' },
      { id: 'metaContent', label: 'Meta description', type: 'input' },
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'imageText', label: 'Image Text', type: 'textarea' },
      { id: 'imagePlay', label: 'Image Play Text', type: 'textarea' },
      { id: 'image', label: 'Banner Image', info: getIdealImageSize(700, 458), type: 'image' },
      { id: 'link', label: 'Image link', type: 'input' }
    ]
  },
  {
    formId: 'form2',
    heading: 'Vision Top Section',
    data: [
      { id: 'title', label: 'Title', type: 'textarea' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' }
    ]
  },
  {
    formId: 'form3',
    heading: 'Vision Bottom Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'image', label: 'Banner Image', info: getIdealImageSize(1280, 535), type: 'image' }
    ]
  },
  {
    formId: 'form4',
    heading: 'Report Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'buttonText', label: 'Button text', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Report Images',
    data: [
      { id: 'image', label: 'Report image', info: getIdealImageSize(1280, 768), type: 'image' }
    ]
  },
  {
    formId: 'form5',
    heading: 'Teams Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' }
    ]
  },
  {
    formId: 'formGroup2',
    heading: 'Teams Members',
    data: [
      { id: 'role', label: 'Role in organisation', type: 'input' },
      { id: 'name', label: 'Member name', type: 'input' },
      { id: 'designation', label: 'Member designation', type: 'input' },
      { id: 'link', label: 'Member LinkedIn link', type: 'input' },
      { id: 'image', label: 'Member image', info: getIdealImageSize(280, 296), type: 'image' }
    ]
  }
];
